import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { media } from '../../../../styles/base';

const styles = makeStyles((theme: Theme) =>
  createStyles({
    averageDetails: {
      alignItems: 'center',
      backgroundColor: '#FFFF',
      borderRadius: 0,
      color: '#000000',
      display: 'flex',
      height: '40px',
      padding: '0 10px',
      textTransform: 'capitalize',
      width: 176,
    },
    averageValues: {
      color: '#323232',
      fontSize: '12px',
      fontWeight: 'bold',
      lineHeight: '15px',
      margin: '0 0 0 5px',
    },
    averagesButton: {
      color: '#323232',
      fontSize: '12px',
      fontWeight: 'bold',
      paddingTop: 10,
      textTransform: 'capitalize',
    },
    averagesContainer: {
      boxShadow: '0 2px 7px 0 rgba(0, 0, 0, 0.25)',
      margin: '50px 0 0 120px',
      position: 'absolute',
      width: 176,
      zIndex: 100,
    },
    avgContainer: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-evenly',
    },
    avgContent: {
      display: 'flex',
      margin: '0 5px',
      marginLeft: 18,
    },
    centerAlign: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'center',
      textTransform: 'lowercase',
    },
    divider: {
      border: `0.5px solid #E7E7E7`,
      margin: '10px 0',
    },
    homesText: {
      color: '#323232',
      fontSize: '12px',
      lineHeight: '15px',
    },
    noOfHomes: {
      color: '#323232',
      fontSize: '12px',
      fontWeight: 'bold',
      lineHeight: '15px',
      margin: '0 5px 0 0',
    },
    noOfHomesContainer: {
      display: 'flex',
      marginRight: 10,
    },
    resetButton: {
      fontSize: '12px',
      fontWeight: 'bold',
      height: 40,
      lineHeight: '15px',
      textTransform: 'capitalize',
    },
    root: {
      alignContent: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      margin: '0',
      padding: '16px 1.5rem 5px 1.5rem',
      backgroundColor: 'white',
    },
    roomPhotoOrderContainer: {
      borderRadius: 10,
      boxShadow: '0 2px 7px 0 rgba(0,0,0,0.25)',
      justifyContent: 'flex-end',
      margin: '0 15px',
      overflow: 'hidden',
      position: 'absolute',
      top: '50px',
      right: '200px',
      width: 460,
      zIndex: 100,
      [media.tablet]: {
        left: '0px',
        margin: '0px',
      },
      [media.mobile]: {
        margin: 0,
        width: '100%',
        right: '0px',
        height: '825px!important',
      },
    },
    selectedButton: {
      '&:hover': {
        backgroundColor: 'rgba(245, 245, 245, 1)',
      },
      backgroundColor: 'rgba(245, 245, 245, 1)',
      borderRadius: 0,
      color: '#000000',
      display: 'flex',
      height: '40px',
      justifyContent: 'space-between',
      left: 0,
      right: 0,
      textTransform: 'capitalize',
      width: '100%',
    },
    sortBy: {
      height: 40,
      justifyContent: 'center',
      padding: 8,
      textTransform: 'capitalize',
      width: 225,
      border: '1px solid rgba(189, 189, 189, 1)',
      borderRadius: '5px',
    },
    sortByText: {
      display: 'block',
      width: '100%',
      overflow: 'hidden',
      marginLeft: 8,
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      textAlign: 'left',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0px',
    },
    sortContainer: {
      width: '100%',
      alignContent: 'center',
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      position: 'relative',
      justifyContent: 'space-between',
      [media.tablet]: {
        margin: 0,
      },
    },
    unSelectedButton: {
      '&:hover': {
        backgroundColor: 'rgba(245, 245, 245, 1)',
      },
      backgroundColor: '#FFFF',
      borderRadius: 0,
      color: '#000000',
      display: 'flex',
      height: '40px',
      justifyContent: 'space-between',
      left: 0,
      right: 0,
      textTransform: 'capitalize',
      width: '100%',
    },
  }),
);

export default styles;
